export default "__VITE_ASSET__CHcaPdDa__"